import { QuizCtaType, QuizLearnerIdentityType } from 'app/types'

export type QuizIdentificationState = {
    identity: QuizLearnerIdentityType | null
    isDismissed: boolean
}

export const getIdentificationMode = (quiz: QuizCtaType) => quiz.identificationMode ?? 'forced'

export const hasAnonymousQuizAccess = (quiz: QuizCtaType, { identity, isDismissed }: QuizIdentificationState) =>
    Boolean(identity) || !isDismissed || getIdentificationMode(quiz) === 'optional'

export const shouldShowIdentificationGate = ({
    isAnonymousViewer,
    identity,
    isDismissed,
}: QuizIdentificationState & { isAnonymousViewer: boolean }) => isAnonymousViewer && !identity && !isDismissed

type CanSkipIdentificationProps = {
    isInLms: boolean
    identificationMode: ReturnType<typeof getIdentificationMode>
    hasRequiredQuizToPass: boolean
}

export const canSkipIdentification = ({
    isInLms,
    identificationMode,
    hasRequiredQuizToPass,
}: CanSkipIdentificationProps) => !(isInLms && identificationMode === 'forced' && hasRequiredQuizToPass)
